/**
 * Citylight adapter — per-type import adapter for 'citylight' media type.
 *
 * Required columns (in addition to COMMON_REQUIRED_COLUMNS):
 * - 'Material'
 * - 'Oswietlenie'
 */
import type { MediaUnitImportAdapter } from './types.js';
import {
  buildBaseRow,
  validateMaterialLighting,
  COMMON_REQUIRED_COLUMNS,
  COMMON_OPTIONAL_COLUMNS,
} from './parse-row.helper.js';

const REQUIRED_COLUMNS = [
  ...COMMON_REQUIRED_COLUMNS,
  'Typ nośnika',
  'Materiał',
  'Oświetlenie',
] as const;

const OPTIONAL_COLUMNS = [...COMMON_OPTIONAL_COLUMNS, 'Szerokość [m]', 'Wysokość [m]'] as const;

export const citylightAdapter: MediaUnitImportAdapter = {
  mediaType: 'citylight',
  requiredColumns: REQUIRED_COLUMNS,
  optionalColumns: OPTIONAL_COLUMNS,

  validate: validateMaterialLighting,

  parseRow(row) {
    return buildBaseRow(row, 'citylight');
  },
};
